import { Navigate, Route, Routes } from 'react-router-dom';

import AssetsPage from '@/pages/AssetsPage';
import CurriculumAdminPage from '@/pages/CurriculumAdminPage';
import DesignRepositoryPage from '@/pages/DesignRepositoryPage';
import EditLessonPackPage from '@/pages/EditLessonPackPage';
import LessonPackDetailPage from '@/pages/LessonPackDetailPage';
import LessonPacksPage from '@/pages/LessonPacksPage';
import NewLessonPackPage from '@/pages/NewLessonPackPage';
import SettingsPage from '@/pages/SettingsPage';

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/lesson-packs" replace />} />
      <Route path="/lesson-packs" element={<LessonPacksPage />} />
      <Route path="/lesson-packs/new" element={<NewLessonPackPage />} />
      <Route path="/lesson-packs/:id" element={<LessonPackDetailPage />} />
      <Route path="/lesson-packs/:id/edit" element={<EditLessonPackPage />} />
      <Route path="/curriculum" element={<CurriculumAdminPage />} />
      <Route path="/design-repository" element={<DesignRepositoryPage />} />
      <Route path="/assets" element={<AssetsPage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="*" element={<Navigate to="/lesson-packs" replace />} />
    </Routes>
  );
}
